import DebitCardVirtual from 'app/shared-components/cards/assets/card-debit-white.svg';
import DebitCardPhysical from 'app/shared-components/cards/assets/card-debit-blue.svg';
import CreditCardPhysical from 'app/shared-components/cards/assets/card-credit-black.svg';
import DebitCardVirtualSmall from 'app/shared-components/cards/assets/card-debit-white-small.png';
import DebitCardPhysicalSmall from 'app/shared-components/cards/assets/card-debit-blue-small.png';
import CreditCardPhysicalSmall from 'app/shared-components/cards/assets/card-credit-black-small.png';
import MobileCardBackground from 'app/shared-components/cards/assets/example.svg';
import { HNCardFormFactor, HighnoteProductType } from 'API';
import type { HnCardFormFactor } from 'CDK_API';

// SEE-1823: card payloads are typed from CDK_API, whose form factor is a string union with
// the same wire values as the Amplify enum. Accept either until the enum is retired.
export type CardFormFactor = HNCardFormFactor | HnCardFormFactor;

export type DefaultCardType = {
  type: HighnoteProductType;
  formFactor: HNCardFormFactor;
  textColor: 'light' | 'dark';
  cardImage: string;
  smallCardImage: string;
  variant?: 'default' | 'mobile'; // Add variant support
};

export const DefaultCardTypes: DefaultCardType[] = [
  {
    type: HighnoteProductType.CREDIT,
    formFactor: HNCardFormFactor.PHYSICAL,
    textColor: 'light',
    cardImage: CreditCardPhysical,
    smallCardImage: CreditCardPhysicalSmall,
    variant: 'default',
  },
  {
    type: HighnoteProductType.DEBIT,
    formFactor: HNCardFormFactor.PHYSICAL,
    textColor: 'light',
    cardImage: DebitCardPhysical,
    smallCardImage: DebitCardPhysicalSmall,
    variant: 'default',
  },
  {
    type: HighnoteProductType.DEBIT,
    formFactor: HNCardFormFactor.VIRTUAL,
    textColor: 'dark',
    cardImage: DebitCardVirtual,
    smallCardImage: DebitCardVirtualSmall,
    variant: 'default',
  },
  // Your mobile card design variants
  {
    type: HighnoteProductType.CREDIT,
    formFactor: HNCardFormFactor.PHYSICAL,
    textColor: 'light',
    cardImage: MobileCardBackground,
    smallCardImage: MobileCardBackground,
    variant: 'mobile',
  },
  {
    type: HighnoteProductType.DEBIT,
    formFactor: HNCardFormFactor.PHYSICAL,
    textColor: 'light',
    cardImage: MobileCardBackground,
    smallCardImage: MobileCardBackground,
    variant: 'mobile',
  },
  {
    type: HighnoteProductType.DEBIT,
    formFactor: HNCardFormFactor.VIRTUAL,
    textColor: 'light', // Your design uses light text
    cardImage: MobileCardBackground,
    smallCardImage: MobileCardBackground,
    variant: 'mobile',
  },
  {
    type: HighnoteProductType.CREDIT,
    formFactor: HNCardFormFactor.VIRTUAL,
    textColor: 'light', // Your design uses light text
    cardImage: MobileCardBackground,
    smallCardImage: MobileCardBackground,
    variant: 'mobile',
  },
];

export const checkCardType = (
  type?: HighnoteProductType,
  formFactor?: CardFormFactor,
  variant: 'default' | 'mobile' = 'default'
): DefaultCardType => {
  // Attempt to find the card type with variant
  const foundCardType = DefaultCardTypes.find(
    (cardType) => cardType.type === type && cardType.formFactor === formFactor && cardType.variant === variant
  );

  // Fallback to default variant if mobile not found
  const fallbackCardType = DefaultCardTypes.find(
    (cardType) =>
      cardType.type === type && cardType.formFactor === formFactor && cardType.variant === 'default'
  );

  // Return found type, fallback, or first entry
  return foundCardType || fallbackCardType || DefaultCardTypes[0];
};
